"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebConference = void 0;

var WebConference =
/** @class */
function () {
  function WebConference() {}

  WebConference.prototype.WebConferenceFormatType = function () {
    return [{
      slug: 'webinar',
      name: 'Webinar',
      description: null,
      isMeeting: false,
      isWebinar: true,
      isNone: false
    }, {
      slug: 'meeting',
      name: 'Meeting',
      description: null,
      isMeeting: true,
      isWebinar: false,
      isNone: false
    }, {
      slug: 'none',
      name: 'None',
      description: null,
      isMeeting: false,
      isWebinar: false,
      isNone: true
    }];
  };

  WebConference.prototype.WebConferenceSourceType = function () {
    return [{
      slug: 'zoom',
      name: 'Zoom',
      description: null,
      isZoom: true,
      isNone: false
    }, {
      slug: 'none',
      name: 'None',
      description: null,
      isZoom: false,
      isNone: true
    }];
  };

  return WebConference;
}();

exports.WebConference = WebConference;